import css from '../tpl-css/style-section-products';
const html = `
<style>${css}</style>
<div data-attribute="card-container" data-id="unique-id" data-background="#FFFFFF" style="background-color: rgb(255, 255, 255);">
  <div class="container products-container">
    <div data-attribute="section-header" class="section-header">
      <h2><span style="color:hsl( 209, 50%, 40% );">Our Best Sellers</span></h2>
      <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Earum labore facilis, vitae non dolores accusamus.
        Rem, alias accusantium!</p>
    </div>
    <div class="wrap-list">
      <div class="swiper swiper-product-unique-id">
        <div data-attribute="list-item" class="swiper-wrapper">
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="wrap-item" class="wrap-item" data-bg="#f6f6f6" data-color="#000000"
              data-radius="10" style="background-color: #f6f6f6; color: #000000; border-radius: 10px;">
              <div class="wrap-img">
                <img data-attribute="img-item" loading="lazy"
                  src="https://cdn.skywarex.com/68d10bd0581b890009c63f7e/2025/09/30/image-68db5817977dfa783daeff8c.webp?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="content-item">
                <div class="wrap-text">
                  <div data-attribute="wrap-rated" data-show-rating="true" class="wrap-rated">
                    <div data-attribute="rating-stars" data-value="5" class="wrap-stars">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                    </div>
                    <div data-attribute="rating-text" class="rating-text">1.095 Reviews</div>
                  </div>
                  <div data-attribute="header-item" class="header-item">
                    <h2>Hugterra™ Head Massager</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                  </div>
                  <div data-show-price="true" class="wrap-price">
                    <div data-show-new="true" data-value="110" data-attribute="price-new" class="price-new">$110
                    </div>
                    <div data-show-old="true" data-value="210" data-attribute="price-old" class="price-old">$210
                    </div>
                    <div data-bg="#6293c1" data-color="#FFFFFF" data-show-sale="true" data-attribute="price-sale"
                      data-value="50" class="price-sale"
                      style="background-color: #6293c1; color: #FFFFFF; display: block;">Save 48%</div>
                  </div>
                </div>
                <div data-radius="10" data-bg="#6293c1" data-color="#FFFFFF" data-attribute="btn-view-more"
                  class="btn-view-more" style="background-color: #6293c1; color: #FFFFFF; border-radius: 10px;">Shop Now
                </div>
              </div>
            </a>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="wrap-item" class="wrap-item" data-bg="#f6f6f6" data-color="#000000"
              data-radius="10" style="background-color: #f6f6f6; color: #000000; border-radius: 10px;">
              <div class="wrap-img">
                <img data-attribute="img-item" loading="lazy"
                  src="https://cdn.skywarex.com/68d10bd0581b890009c63f7e/2025/09/30/image-68db580f0f835851964b2b7a.webp?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="content-item">
                <div class="wrap-text">
                  <div data-attribute="wrap-rated" data-show-rating="true" class="wrap-rated">
                    <div data-attribute="rating-stars" data-value="5" class="wrap-stars">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                    </div>
                    <div data-attribute="rating-text" class="rating-text">1.015 Reviews</div>
                  </div>
                  <div data-attribute="header-item" class="header-item">
                    <h2>Hugterra™ Massager</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                  </div>
                  <div data-show-price="true" class="wrap-price">
                    <div data-show-new="true" data-value="139" data-attribute="price-new" class="price-new">$139
                    </div>
                    <div data-show-old="true" data-value="300" data-attribute="price-old" class="price-old">$300
                    </div>
                    <div data-bg="#6293c1" data-color="#FFFFFF" data-show-sale="true" data-attribute="price-sale"
                      data-value="50" class="price-sale"
                      style="background-color: #6293c1; color: #FFFFFF; display: block;">Save 50%</div>
                  </div>
                </div>
                <div data-radius="10" data-bg="#6293c1" data-color="#FFFFFF" data-attribute="btn-view-more"
                  class="btn-view-more" style="background-color: #6293c1; color: #FFFFFF; border-radius: 10px;">Shop Now
                </div>
              </div>
            </a>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="wrap-item" class="wrap-item" data-bg="#f6f6f6" data-color="#000000"
              data-radius="10" style="background-color: #f6f6f6; color: #000000; border-radius: 10px;">
              <div class="wrap-img">
                <img data-attribute="img-item" loading="lazy"
                  src="https://cdn.skywarex.com/68d10bd0581b890009c63f7e/2025/09/30/image-68db581f7346a106283e7b8d.webp?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="content-item">
                <div class="wrap-text">
                  <div data-attribute="wrap-rated" data-show-rating="true" class="wrap-rated">
                    <div data-attribute="rating-stars" data-value="5" class="wrap-stars">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                    </div>
                    <div data-attribute="rating-text" class="rating-text">1.011 Reviews</div>
                  </div>
                  <div data-attribute="header-item" class="header-item">
                    <h2>Hugterra™ Massager</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                  </div>
                  <div data-show-price="true" class="wrap-price">
                    <div data-show-new="true" data-value="110" data-attribute="price-new" class="price-new">$110
                    </div>
                    <div data-show-old="true" data-value="250" data-attribute="price-old" class="price-old">$250
                    </div>
                    <div data-bg="#6293c1" data-color="#FFFFFF" data-show-sale="true" data-attribute="price-sale"
                      data-value="50" class="price-sale"
                      style="background-color: #6293c1; color: #FFFFFF; display: block;">Save 56%</div>
                  </div>
                </div>
                <div data-radius="10" data-bg="#6293c1" data-color="#FFFFFF" data-attribute="btn-view-more"
                  class="btn-view-more" style="background-color: #6293c1; color: #FFFFFF; border-radius: 10px;">Shop Now
                </div>
              </div>
            </a>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <a href="#" data-attribute="wrap-item" class="wrap-item" data-bg="#f6f6f6" data-color="#000000"
              data-radius="10" style="background-color: #f6f6f6; color: #000000; border-radius: 10px;">
              <div class="wrap-img">
                <img data-attribute="img-item" loading="lazy"
                  src="https://cdn.skywarex.com/68d10bd0581b890009c63f7e/2025/09/30/image-68db581f7346a106283e7b8d.webp?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="content-item">
                <div class="wrap-text">
                  <div data-attribute="wrap-rated" data-show-rating="true" class="wrap-rated">
                    <div data-attribute="rating-stars" data-value="5" class="wrap-stars">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                        <!---->
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                        </path>
                        <!----><!----><!---->
                      </svg>
                    </div>
                    <div data-attribute="rating-text" class="rating-text">1.011 Reviews</div>
                  </div>
                  <div data-attribute="header-item" class="header-item">
                    <h2>Hugterra™ Massager</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                  </div>
                  <div data-show-price="true" class="wrap-price">
                    <div data-show-new="true" data-value="110" data-attribute="price-new" class="price-new">$110
                    </div>
                    <div data-show-old="true" data-value="250" data-attribute="price-old" class="price-old">$250
                    </div>
                    <div data-bg="#6293c1" data-color="#FFFFFF" data-show-sale="true" data-attribute="price-sale"
                      data-value="50" class="price-sale"
                      style="background-color: #6293c1; color: #FFFFFF; display: block;">Save 56%</div>
                  </div>
                </div>
                <div data-radius="10" data-bg="#6293c1" data-color="#FFFFFF" data-attribute="btn-view-more"
                  class="btn-view-more" style="background-color: #6293c1; color: #FFFFFF; border-radius: 10px;">Shop Now
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="button-next next-unique-id">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-chevron-right-icon lucide-chevron-right">
            <path d="m9 18 6-6-6-6" />
          </svg>
        </div>
        <div class="button-prev prev-unique-id">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-chevron-left-icon lucide-chevron-left">
            <path d="m15 18-6-6 6-6" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>

`;

export default html;
